export const state = () => ({
  localAuthTypes: [],
  loginMode: null,
  autologinPayload: null,
  rememberedUsername: null,
});

export const mutations = {
  setLocalAuthTypes(state, data) {
    state.localAuthTypes = data;
  },
  setLoginMode(state, data) {
    state.loginMode = data;
  },
  setAutologinPayload(state, data) {
    state.autologinPayload = data;
  },
  setVariables(state, variables) {
    state.variables = variables;
  },
  setRememberedUsername(state, data) {
    state.rememberedUsername = data;
  },
};
if (process.client) {
  window.sendToWebView = function (action, payload) {
    const message = JSON.stringify({ action, payload });
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(message);
    }
  };
}
